import React from "react";
import clsx from "clsx";

import { ReactComponent as IconGoodOn } from "../../assets/images/AnswerList/icon_good_on.svg";
import { ReactComponent as IconGoodOff } from "../../assets/images/AnswerList/icon_good_off.svg";
import { ReactComponent as IconCommentOn } from "../../assets/images/AnswerList/icon_comment_on.svg";
import { ReactComponent as IconCommentOff } from "../../assets/images/AnswerList/icon_comment_off.svg";
import OneAnswerContents from "../OneAnswerContents";
import FormReply from "../../organisms/student/FormReply";
import FormComment from "../../organisms/student/FormComment";
import { IAnswerR, IStudent } from "../../state";

import style from "./OneAnswerBox.module.scss";

type OneAnswerBoxProps = {
  name_opened: boolean;
  answer: IAnswerR;
  isMyAnswer?: boolean;
  handleLike: (answerId: number) => void;
  replyAnswer: (content: string, answerId: number) => void;
  updateReply: (content: string, answerId: number, commentId?: number) => void;
  currentUser?: IStudent;
  onDeleteReply: (answerId: number, commentId: number) => void;
  calling: boolean;
};

export const OneAnswerBox: React.FC<OneAnswerBoxProps> = ({
  name_opened,
  answer,
  isMyAnswer,
  handleLike,
  replyAnswer,
  currentUser,
  onDeleteReply,
  updateReply,
  calling,
}) => {
  const [isCommentOpen, setIsCommentOpen] = React.useState(false);

  const replyAnswerWithKeepOpen = React.useCallback(
    (content: string, answerId: number) => {
      setIsCommentOpen(true);
      replyAnswer(content, answerId);
    },
    [replyAnswer],
  );

  const updateReplyWithKeepOpen = React.useCallback(
    (content: string, answerId: number, commentId?: number) => {
      setIsCommentOpen(true);
      updateReply(content, answerId, commentId);
    },
    [updateReply],
  );

  return (
    <div className={clsx(style.wrapper_content, isMyAnswer && style.myAnswer)}>
      {answer.contents && <OneAnswerContents contents={answer.contents} />}
      <div className={style.header}>
        <button
          className={style.button}
          disabled={calling}
          onClick={() => {
            handleLike(answer.id);
          }}
        >
          {answer.is_like ? <IconGoodOn /> : <IconGoodOff />}
          <span>{answer.like_num}人</span>
        </button>
        <button
          className={style.button}
          onClick={() => setIsCommentOpen(!isCommentOpen)}
          aria-expanded={isCommentOpen}
        >
          {answer.comments.length > 0 ? <IconCommentOn /> : <IconCommentOff />}
          <span>{answer.comments.length}件</span>
        </button>
      </div>
      <div
        className={isCommentOpen ? "collapse show" : "collapse"}
        id={`reply-${answer.id}`}
      >
        <div className={style.comment}>
          {answer.comments.length > 0 && (
            <div className={style.commentList}>
              {answer.comments.map(comment => (
                <FormReply
                  key={comment.id}
                  comment={comment}
                  onSendComment={updateReplyWithKeepOpen}
                  onDeleteReply={onDeleteReply}
                  currentUser={currentUser}
                  answerId={answer.id}
                  name_opened={name_opened}
                  calling={calling}
                />
              ))}
            </div>
          )}
          <div className={style.replyAnswer}>
            <FormComment
              answer={answer}
              replyAnswer={replyAnswerWithKeepOpen}
              calling={calling}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneAnswerBox;
